import { render, staticRenderFns } from "./ModeloCombobox.vue?vue&type=template&id=c6fae798&scoped=true&"
import script from "./ModeloCombobox.vue?vue&type=script&lang=js&"
export * from "./ModeloCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fae798",
  null
  
)

export default component.exports